import axios from '@/axios.js'

export default {
  getTotalStatistics (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/dashboard/${payload.companyID}/total/${payload.startDate}/${payload.endDate}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getCashbooks (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/dashboard/${payload.companyID}/graph/${payload.startDate}/${payload.endDate}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
